import { analytics, FreePlanBannerEvents } from '@/lib/analytics'

export type FreePlanBannerSource = 'sidebar' | 'mobile-banner'

interface FreePlanBannerEventData {
  source: FreePlanBannerSource
  envelopesLeft: number
  envelopesTotal: number
  depleted: boolean
}

function toPayload(data: FreePlanBannerEventData) {
  return {
    source: data.source,
    envelopes_left: data.envelopesLeft,
    envelopes_total: data.envelopesTotal,
    depleted: data.depleted,
  }
}

export function trackFreePlanBannerViewed(data: FreePlanBannerEventData): void {
  analytics.track(FreePlanBannerEvents.VIEWED, toPayload(data))
}

export function trackFreePlanBannerClicked(
  data: FreePlanBannerEventData,
): void {
  analytics.track(FreePlanBannerEvents.CLICKED, toPayload(data))
}
